import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ButtonEditor } from "./Editor";
import { PrimaryButton } from "./PrimaryButton";
import { defaultData } from "./PrimaryButtonBlockDefaultData";
import { meta } from "./PrimaryButtonBlockMetaData";

export const PrimaryButtonBlock: BlockExport = {
  type: "component",
  Block: PrimaryButton,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-button",
    size: 24,
  },
  defaultData,
  Editor: ButtonEditor,
  meta,
};
